import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Owner from "@/pages/Owner";

const AuthShell = ({ children }) => (
  <div className="starfield min-h-screen flex flex-col items-center justify-center gap-8 px-4 py-12">
    <Link to="/" data-testid="auth-home-link" className="font-display text-gold text-lg tracking-widest">EARTH ANGEL</Link>
    {children}
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/owner" element={<Owner />} />
            <Route path="/sign-in/*" element={<AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthShell>} />
            <Route path="/sign-up/*" element={<AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthShell>} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
